import { render, staticRenderFns } from "./StatusBar.vue?vue&type=template&id=96400b6c&scoped=true"
import script from "./StatusBar.vue?vue&type=script&lang=js"
export * from "./StatusBar.vue?vue&type=script&lang=js"
import style0 from "./StatusBar.vue?vue&type=style&index=0&id=96400b6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96400b6c",
  null
  
)

export default component.exports